"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUrlParams = void 0;
const router_1 = require("next/router");
const react_1 = require("react");
const urls_1 = require("../lib/urls");
const useCurrentRef_1 = require("./useCurrentRef");
function useUrlParams() {
    const router = router_1.useRouter();
    const currentUrlRef = useCurrentRef_1.useCurrentRef(router.asPath);
    const replaceUrlRef = useCurrentRef_1.useCurrentRef(router.replace);
    const urlParams = urls_1.getUrlParams(router.asPath);
    const urlParamsRef = useCurrentRef_1.useCurrentRef(urlParams);
    const setNewParams = react_1.useCallback((params, options) => {
        const currentUrl = currentUrlRef.current;
        const newUrl = urls_1.createUrl(currentUrl, params);
        const replaceUrl = replaceUrlRef.current;
        if (currentUrl !== newUrl) {
            replaceUrl(newUrl, undefined, options !== null && options !== void 0 ? options : { shallow: true }).catch(console.error);
        }
    }, [replaceUrlRef, currentUrlRef]);
    const setUrlParams = react_1.useCallback((name, value, options) => {
        setNewParams(typeof name === 'object' ? name : Object.assign(Object.assign({}, urlParamsRef.current), { [name]: value }), options);
    }, [setNewParams, urlParamsRef]);
    return [urlParams, setUrlParams];
}
exports.useUrlParams = useUrlParams;
